import { useEffect, useState } from 'react';

import { Modal, Button, Form, Input, Select, Slider, DatePicker, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { sortBy } from 'lodash';

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24
	}
};

export const StakeEditionModal = (props: any) => {
	const [form] = Form.useForm();
	const [areTooltipVisibles, setAreTooltipVisibles] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		setTimeout(() => {
			setAreTooltipVisibles(true);
		}, 400)
	}, []);


	const handleFormSubmit = () => {
		console.log('handleFormSubmit');
		form.validateFields()
			.then((values) => {
				console.log('validated', values);
				props.onSave(values);
				props.onHide();
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo);
			});
	};

	const footer = (
		<div style={{ display: 'flex' }}>
			{props.onDelete && (
				<Button
					onClick={() => {
						props.onDelete(props);
					}}
					danger={true}
					style={{ marginRight: 'auto' }}
					data-testid="stake-delete-button"
				>
					{t('actions.delete')}
				</Button>
			)}
			<Button
				onClick={() => {
					props.onHide();
				}}
				style={{ marginRight: 'auto' }}
				data-testid="stake-close-button"
			>
				{t('actions.close')}
			</Button>
			<Button onClick={handleFormSubmit} type="primary" data-testid="stake-save-button">
				{t('actions.save')}
			</Button>
		</div>
	);

	console.log('StakeEditionModal props', props);

	return (
		<Modal
			open={true}
			width={props.width || "70%"}
			title={props.id ? t('models.stake.actions.edit') : t('models.stake.actions.create_new')}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText={t('actions.close')}
			footer={footer}
			maskClosable={false}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={(values) => {
					props.onChange(props.id, values);
					props.onHide();
				}}
				initialValues={props.values}
			>
				<Flex vertical={false}>
					<Form.Item
						name="reference"
						label={t("models.indicator.fields.reference")}
						className="mr-1"
						style={{ width: '20%' }}
						rules={[
							{
								max: 5,
								message:
									t("messages.form.max_length_exceeded_error", { length: 5 })
							}
						]}
					>
						<Input
							autoComplete='off'
							count={{
								show: true,
								max: 5,
							}}></Input>
					</Form.Item>
					<Form.Item
						name="name"
						label={t("models.indicator.fields.name")}
						required={true}
						className='mr-1'
						style={{ width: '60%' }}
						rules={[
							{
								max: 35,
								message:
									t("messages.form.max_length_exceeded_error", { length: 35 })
							},
							{
								required: true,
								message: t("messages.form.required_error")
							}
						]}
					>
					<Input
						autoComplete='off'
						data-testid="stake-name-input"
						count={{
							show: true,
							max: 35,
						}}></Input>
					</Form.Item>
					<Form.Item
						name="evaluatedAt"
						label={t("models.stake.fields.evaluated_at")}
						required={false}
						style={{ width: '20%' }}
					>
						<DatePicker
							style={{ zIndex: '2000' }}
							format={'DD/MM/YYYY HH:mm'}
							className='w-100'
							showTime={{
								format: 'HH:mm',
								minuteStep: 15
							}}></DatePicker>
					</Form.Item>
				</Flex>
			<Form.Item name="description" label={t("models.stake.fields.description")} rules={[
				{
					max: 300,
					message:
						t("messages.form.max_length_exceeded_error", { length: 300 })
				}
			]}>
				<Input.TextArea
					rows={5}
					data-testid="stake-description-textarea"
					count={{
						show: true,
						max: 300,
					}}></Input.TextArea>
			</Form.Item>
				<Form.Item name="weight" label={t("models.stake.fields.weight")}>
					<Slider
						tooltip={{ placement: 'right', open: areTooltipVisibles }}
						dots={true}
						min={1}
						max={3}
					/>
				</Form.Item>

			{(props.tags || []).length > 0 && (
				<Form.Item name="taggings" label="Tags">
					<Select
						mode="multiple"
						allowClear
						style={{ width: '100%' }}
						placeholder={t('messages.search')}
						options={sortBy(props.tags || [], 'name')}
						fieldNames={{ label: 'name', value: 'id' }}
					/>
				</Form.Item>
			)}
			</Form>
		</Modal>
	);
};

export default StakeEditionModal;
